import { Button, Modal } from 'antd';
import React, { FC } from 'react';
import style from './index.module.scss';

type TAcceptDeleteModalOpen = {
  acceptDeleteModalOpen: boolean;
  setAcceptDeleteModalOpen: (data: boolean) => void;
  onDelete: () => void;
};

const AcceptDeleteCategoryModal: FC<TAcceptDeleteModalOpen> = ({
  acceptDeleteModalOpen,
  setAcceptDeleteModalOpen,
  onDelete,
}) => {
  const handleCancel = () => {
    setAcceptDeleteModalOpen(false);
  };

  const handleDelete = () => {
    setAcceptDeleteModalOpen(false);
    onDelete();
  };

  return (
    <Modal
      title="В данной категории есть вопрос-ответы, вы уверены что хотите удалить ее?"
      footer={false}
      onCancel={handleCancel}
      open={acceptDeleteModalOpen}
      bodyStyle={{ padding: '40px' }}
      width={400}
      destroyOnClose
      zIndex={99999}
    >
      <div className={style.buttons}>
        <Button type="primary" onClick={handleCancel}>
          Оставить
        </Button>
        <Button onClick={handleDelete} danger>
          Удалить
        </Button>
      </div>
    </Modal>
  );
};

export default AcceptDeleteCategoryModal;
